import {
  ApplicationConfig,
  inject,
  importProvidersFrom,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from "@angular/core";
import { provideRouter } from "@angular/router";

import { routes } from "./app.routes";

import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { provideAnimations } from "@angular/platform-browser/animations";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";
import { InlineSVGModule } from "ng-inline-svg-2";
import { SharedModule } from "src/shared/shared.module";
import { AuthService } from "./pages/auth";
import { appInitializer } from "src/utils/app-intialization";
import { httpClientInterceptor } from "src/utils/http-client.intercepter";
import { provideSweetAlert2 } from "@sweetalert2/ngx-sweetalert2";
import { NgxPermissionsService, NgxPermissionsModule } from "ngx-permissions";
import { MAT_DIALOG_DEFAULT_OPTIONS } from "@angular/material/dialog";

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    // provideClientHydration(withEventReplay()),

    // ✅ animations
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    provideAnimations(),

    provideSweetAlert2(),

    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: { disableClose: true },
    },

    // ✅ http client
    provideHttpClient(withInterceptors([httpClientInterceptor])),

    // ✅ translate, clipboard, svg, ng-bootstrap, sweetalert2, shared
    importProvidersFrom(
      TranslateModule.forRoot(),
      InlineSVGModule.forRoot(),
      NgxPermissionsModule.forRoot(),
      NgbModule,
      SharedModule,
    ),
    // ✅ app initializer
    provideAppInitializer(async () => appInitializer(inject(AuthService))()),
  ],
};
